import IconWrapper from './icon-wrapper';

const normalIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.43377 5.04415L9.4453 2.3698C9.7812 2.14587 10.2188 2.14587 10.5547 2.3698L14.5662 5.04415C15.2051 5.47006 15.1455 6.42725 14.4587 6.77063L10.4472 8.77639C10.1657 8.91716 9.83431 8.91716 9.55279 8.77639L5.54126 6.77063C4.8545 6.42725 4.7949 5.47006 5.43377 5.04415Z"
      fill="url(#paint0_linear_4059_1066)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00772 1.41525C9.62259 1.0639 10.3774 1.0639 10.9923 1.41525L17.4961 5.13174C17.8077 5.30978 18 5.64113 18 5.99998V13.4197C18 14.1374 17.6154 14.8001 16.9923 15.1561L10.4961 18.8682C10.1887 19.0439 9.81129 19.0439 9.50386 18.8682L3.00772 15.1561C2.38457 14.8001 2 14.1374 2 13.4197V5.99998C2 5.64113 2.19229 5.30978 2.50386 5.13174L9.00772 1.41525ZM4 7.61802L9 10.118V16.2768L4 13.4197V7.61802ZM11 16.2768L16 13.4197V7.61802L11 10.118V16.2768ZM10 8.38195L14.8815 5.94118L10 3.15173L5.11847 5.94118L10 8.38195Z"
      fill="#595959"
    />
    <defs>
      <linearGradient id="paint0_linear_4059_1066" x1="4" y1="3" x2="4" y2="9" gradientUnits="userSpaceOnUse">
        <stop stopColor="#B9B9B9" />
        <stop offset="1" stopColor="#7B7B7B" stopOpacity="0.01" />
      </linearGradient>
    </defs>
  </svg>
);

const activedIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.43377 5.04415L9.4453 2.3698C9.7812 2.14587 10.2188 2.14587 10.5547 2.3698L14.5662 5.04415C15.2051 5.47006 15.1455 6.42725 14.4587 6.77063L10.4472 8.77639C10.1657 8.91716 9.83431 8.91716 9.55279 8.77639L5.54126 6.77063C4.8545 6.42725 4.7949 5.47006 5.43377 5.04415Z"
      fill="url(#paint0_linear_4059_1069)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00772 1.41525C9.62259 1.0639 10.3774 1.0639 10.9923 1.41525L17.4961 5.13174C17.8077 5.30978 18 5.64113 18 5.99998V13.4197C18 14.1374 17.6154 14.8001 16.9923 15.1561L10.4961 18.8682C10.1887 19.0439 9.81129 19.0439 9.50386 18.8682L3.00772 15.1561C2.38457 14.8001 2 14.1374 2 13.4197V5.99998C2 5.64113 2.19229 5.30978 2.50386 5.13174L9.00772 1.41525ZM4 7.61802L9 10.118V16.2768L4 13.4197V7.61802ZM11 16.2768L16 13.4197V7.61802L11 10.118V16.2768ZM10 8.38195L14.8815 5.94118L10 3.15173L5.11847 5.94118L10 8.38195Z"
      fill="#2D64FF"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4059_1069"
        x1="2.6039"
        y1="6.14856"
        x2="17.9423"
        y2="5.81324"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B3EE" />
        <stop offset="1" stopColor="#2BCAFF" stopOpacity="0.01" />
      </linearGradient>
    </defs>
  </svg>
);

export default function IconPlatformMarketing() {
  return <IconWrapper normalIcon={normalIcon} activedIcon={activedIcon} />;
}
